import { CatalogTypePage } from './CatalogTypePage';
import { CatalogCabinetFormPage } from './CatalogCabinetFormPage';

const SHARED = {
  type: 'CABINET' as const,
  i18nNs: 'cabinets',
  listTo: '/cabinets' as const,
  newTo: '/cabinets/new' as const,
  editToParent: '/cabinets/$id' as const,
  editParentRouteId: '/protected/cabinets/$id' as const,
};

export function CabinetsListPage() {
  return (
    <CatalogTypePage
      type={SHARED.type}
      i18nNs={SHARED.i18nNs}
      listTo={SHARED.listTo}
      newTo={SHARED.newTo}
      editToParent={SHARED.editToParent}
    />
  );
}

export function CabinetCreatePage() {
  return <CatalogCabinetFormPage mode="create" />;
}

export function CabinetEditPage() {
  return <CatalogCabinetFormPage mode="edit" />;
}
